import { cuPlugin } from "@/tinymce/plugins/myCustomToolbarButton/plugin.js";

const config = {
    height: "100%",
    toolbar_location: "top",
    content_style: "body#tinymce { margin-bottom: 50px; }",
    menubar: false,
    // no Heading 1 in the text editor (h1 is reserved for the page); keep h2..h6
    block_formats: "Paragraph=p;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre",
    plugins: ["advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks code fullscreen typography", "insertdatetime media table paste code help wordcount", "myCustomToolbarButton"],
    contextmenu: false,
    toolbar:
        "undo redo | formatselect | bold italic underline | \
        alignleft aligncenter alignright alignjustify | \
        numlist bullist | forecolor backcolor | link myCustomToolbarButton media image | removeformat | code",
    toolbar2:
        "undo redo | formatselect | bold italic underline | \
        alignleft aligncenter alignright alignjustify |  \
        numlist bullist | forecolor backcolor | link myCustomToolbarButton media image | removeformat | code",
    setup: function () {
        window.tinymce.PluginManager.add("myCustomToolbarButton", cuPlugin);
        // rename the native link plugin's "Link list" dropdown to "Internal links"
        if (window.tinymce && window.tinymce.addI18n) {
            window.tinymce.addI18n("en", { "Link list": "Internal links" });
        }
    },
};

export default { config };
